<div class="multicheck-filter-container">
  @if (showFilter) {
    <div class="multicheck-search-box">
      <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input
        #search
        type="text"
        class="multicheck-search-input"
        placeholder="Search..."
        [value]="searchValue ?? ''"
        (input)="onInput($event)"
        (keydown.enter)="onSearch()"
      />
      @if (searchValue) {
        <button type="button" class="clear-search-btn" (click)="clearSearch($event)" title="Clear search">
          <svg viewBox="0 0 16 16" fill="currentColor">
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>
      }
    </div>
  }

  @if (currentData && currentData.length > 0) {
    <div class="multicheck-actions-bar">
      <label class="select-all-label" (click)="toggleSelectAll($event)">
        <input
          type="checkbox"
          class="filter-checkbox"
          [checked]="areAllSelected"
          [indeterminate]="isSomeSelected"
        />
        <span class="select-all-text">Select All</span>
      </label>
      <span class="items-count">{{ selectedCount }} / {{ currentData.length }}</span>
    </div>
  }

  <ul class="multicheck-items-list">
    @for (item of currentData; track item; let i = $index) {
      <li
        #itemElement
        class="multicheck-item"
        [class.is-selected]="isItemSelected(item)"
        (click)="onSelectionChange(valueAccessor(item), itemElement)"
      >
        <input
          type="checkbox"
          class="filter-checkbox"
          [checked]="isItemSelected(item)"
          tabindex="-1"
        />
        <span class="item-text" [title]="textAccessor(item)">{{ textAccessor(item) }}</span>
      </li>
    }
    @empty {
      <li class="empty-notice">No matches found</li>
    }
  </ul>
</div>
